import { render, staticRenderFns } from "./Inventaris.vue?vue&type=template&id=44c1e86a"
import script from "./Inventaris.vue?vue&type=script&lang=js"
export * from "./Inventaris.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports